// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { useMemo } from 'react';
import { DenyList } from '@daml.js/dtc-registry/lib/Dtc/Registry/V3/Rbac/Deny';
import TemplateContract from '../../../../utils/TemplateContract';
import { useOperatorBasedQuery } from '../../useOperatorBasedQuery';

const CLIENT_ONBOARDER_DENY_LIST_PREFIX = 'client-onboarder-deny-list-';

export const useOperatorDenyLists: () => UseQueryResult<
  TemplateContract<DenyList>[],
  string
> = () =>
  useOperatorBasedQuery('queryDenyLists', (ledgerApi, offset, operator) =>
    ledgerApi.queryOperatorDenyLists(offset, operator),
  );

const useDenyLists = (): UseQueryResult<TemplateContract<DenyList>[], string> => {
  const query = useOperatorBasedQuery('queryDenyLists', (ledgerApi, offset, operator) =>
    ledgerApi.queryOperatorDenyLists(offset, operator),
  );

  const filtered = useMemo(
    () => query.data?.filter((dl) => dl.payload.name.startsWith(CLIENT_ONBOARDER_DENY_LIST_PREFIX)),
    [query.data],
  );

  return { ...query, data: filtered } as UseQueryResult<TemplateContract<DenyList>[], string>;
};

export default useDenyLists;
